import { merge } from 'lodash';
import Tenancy from 'app/lib/tenancy';
import Http from '../lib/http';
import { cookies } from 'app/lib/storage';
import { CookieUniqueId } from 'app/config/constants';

// Can not use destructuring because the values do no show up for Now deployment
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
const API_URL = process.env.API_URL;
const STAGE = process.env.STAGE;
const VERSION = process.env.VERSION;
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */

const grxUniqueId = cookies.get()[CookieUniqueId.GRX];
const DefaultConfig = {
  ApiUrl: `${API_URL}/v1`,
  WebSocketHost: API_URL,
  Env: STAGE,
  Dev: STAGE === 'dev',
  Beta: STAGE === 'beta',
  Prod: STAGE === 'prod',
  Feature: STAGE === 'feature',
  Legals: {},
  Social: [],
  ApiDefaultHeaders: {
    'X-Device-Platform': 'web',
    'X-Device-Platform-Version': VERSION,
    ...(grxUniqueId && { 'X-Grx-Unique-Id': grxUniqueId }),
  },
  StripePublicKey: 'pk_test_gyfA3PBNj1UMtebm2YEfPlUO',
  PhoneNumbers: {
    TRANSACTIONAL_ALERTS: STAGE === 'prod' ? '(415) 429-1395' : '(415) 429-3651',
  },
  OptimizelySdkKey: 'HiS5UNzL9aGhjaJoJiJj4',
  MaintenanceBannerEnabled: false,
  MaintenanceBannerMessage:
    'HeyDoctor will be down for scheduled maintenance on October 7th from 9PM - 12AM PST. Thank you for your patience.',
  MaintenancePageEnabled: false,
};

const StageConfig = {
  beta: {},
  feature: {},
  prod: {
    OptimizelySdkKey: 'QYARmS7eGBxdFjqvnT5QE',
    StripePublicKey: 'pk_live_hMlJWgTry5Y0KrAd1s9EKrbv',
  },
};

const config = merge(DefaultConfig, StageConfig[STAGE!], Tenancy.getConfig());

Http.setBaseUrl(config.ApiUrl);
Http.setHeaders({
  'X-Client': 'heydoctor',
  'X-Api-Key': 'heydoctor',
  'X-Device-Platform': 'web',
  'X-Device-Platform-Version': 1,
});

export default config;
